export default function BrandedPageLoader({ message = "Loading", subtext = "Preparing your workspace" }) {
  return (
    <div className="min-h-screen w-full bg-background flex items-center justify-center px-6" data-testid="page-loader">
      <div className="relative flex flex-col items-center text-center">
        <div className="absolute -inset-10 rounded-full bg-primary/5 blur-2xl" />
        <div className="relative h-24 w-24 rounded-full bg-card border border-border shadow-sm flex items-center justify-center">
          <div className="absolute inset-2 rounded-full border-2 border-primary/15" />
          <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-accent border-r-primary animate-spin" />
          <div className="h-12 w-12 rounded-2xl bg-primary text-primary-foreground flex items-center justify-center font-display text-2xl font-black shadow-sm">
            Q
          </div>
        </div>
        <div className="relative mt-6 space-y-2">
          <p className="font-display text-lg font-semibold text-foreground">{message}</p>
          <p className="text-sm text-muted-foreground">{subtext}</p>
        </div>
        <div className="relative mt-5 flex items-center gap-2">
          <span className="h-2 w-2 rounded-full bg-primary animate-pulse" />
          <span className="h-2 w-8 rounded-full bg-accent/70 animate-pulse [animation-delay:150ms]" />
          <span className="h-2 w-2 rounded-full bg-primary/50 animate-pulse [animation-delay:300ms]" />
        </div>
      </div>
    </div>
  );
}
